import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'app/admin.service';

@Component({
  selector: 'app-hsn-gst-edit',
  templateUrl: './hsn-gst-edit.component.html',
  styleUrls: ['./hsn-gst-edit.component.scss']
})
export class HsnGstEditComponent {

  productList: any[] = [];

  hsn_data: any[] = []; // current list bound to dropdown
  itemHsnList: any[] = [];
  serviceSacList: any[] = [];
  fixedAssetHsnList: any[] = [];

  taxOptions: any[] = [];


  constructor(
    public dialogRef: MatDialogRef<HsnGstEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adminService: AdminService
  ) {
    this.productList = JSON.parse(JSON.stringify(data.productList));
    this.taxOptions = data.taxOptions || [];
  }

ngOnInit(): void {

  // 🔥 DEDUPLICATE FOR EDIT VIEW
  this.productList = this.productList.map(product => {

    const map = new Map<string, any>();
    console.log('product', product);

    product?.details?.forEach(detail => {

      let key = '';

      if (detail.item_service_type === 'SKU') {
        key = 'SKU_' + (detail.sku_id || detail?.sku?.id);
      }

      if (detail.item_service_type === 'Service') {
        key = 'SERVICE_' + (detail.sku_id || detail?.service?.id);
      }

      if (detail.item_service_type === 'Fixed Asset') {
        key = 'FIXED_ASSET_' + (detail.sku_id || detail?.fa_template?.id);
      }

      if (!map.has(key)) {
        map.set(key, detail); // keep first only
      }
    });

    return {
      ...product,
      details: Array.from(map.values())
    };
  });

  /* -------------------------------
     existing ngOnInit logic continues
  -------------------------------- */

  this.fetchHsnData('item');
  this.fetchHsnData('service');

  this.productList.forEach(product => {
    product.details?.forEach(detail => {

      if (detail.item_service_type === 'SKU') {
        detail.hsn_no =
          detail.hsn_no ||
          detail?.hsn_sac?.hsn_sac_no;
      }

      if (detail.item_service_type === 'Service') {
        detail.hsn_no =
          detail.hsn_no ||
          detail?.hsn_sac?.hsn_sac_no;
      }

      if (detail.item_service_type === 'Fixed Asset') {
        detail.hsn_no =
          detail.hsn_no ||
          detail?.hsn_sac?.hsn_sac_no;
      }

      if (detail.hsn_sac?.gst_id) {
        detail.taxType = detail.hsn_sac.gst_id;
      }
    });
  });
}




fetchHsnData(type: 'item' | 'service') {
  this.adminService.getHsnSacType(type).subscribe(
    (response) => {

      if (type === 'item') {
        this.itemHsnList = response.data || [];
        this.fixedAssetHsnList = response.data || [];
        // console.log('itemHsnList', this.itemHsnList);
        console.log('fixedAssetHsnList', this.fixedAssetHsnList);
      }

      if (type === 'service') {
        this.serviceSacList = response.data || [];

        // 🔥 Force auto-select for Service rows
        this.productList.forEach(product => {
          product.details?.forEach(detail => {
            if (
              detail.item_service_type === 'Service' &&
              detail.hsn_no
            ) {
              detail.hsn_no = detail.hsn_no; // re-bind
            }
          });
        });
      }
    }
  );
}


  // onHsnChange(detail: any) {
  //   const sourceList =
  //     detail.item_service_type === 'SKU'
  //       ? this.itemHsnList
  //       : this.serviceSacList;

  //   const match = sourceList.find(h => h.hsn_sac_no === detail.hsn_no);
  //   detail.hsn_sac = match || null;

  //   if (match?.gst_id) {
  //     detail.taxType = match.gst_id;
  //   }
  // }
onHsnChange(detail: any) {

  const sourceList =
    detail.item_service_type === 'SKU'
      ? this.itemHsnList
      : detail.item_service_type === 'Service'
      ? this.serviceSacList
      : detail.item_service_type === 'Fixed Asset'
      ? this.fixedAssetHsnList
      : [];

  const match = sourceList.find(h => h.hsn_sac_no === detail.hsn_no);
  if (!match) return;

  // 🔥 Update ALL matching original details
  this.data.productList.forEach(product => {
    product.details?.forEach(d => {

      const sameItem =
        (detail.item_service_type === 'SKU' &&
          d.item_service_type === 'SKU' &&
          (d.sku_id || d?.sku?.id) === (detail.sku_id || detail?.sku?.id)) ||

        (detail.item_service_type === 'Service' &&
          d.item_service_type === 'Service' &&
          (d.service_id || d?.service?.id) === (detail.service_id || detail?.service?.id)) ||

        (detail.item_service_type === 'Fixed Asset' &&
          d.item_service_type === 'Fixed Asset' &&
          (d.sku_id || d?.fa_template?.id) === (detail.sku_id || detail?.fa_template?.id));

      if (sameItem) {
        d.hsn_no = match.hsn_sac_no;
        d.hsn_sac = match;

        // ✅ THIS IS THE FIX
        d.taxType = match.gst_id;
      }
    });
  });

  // 🔁 Also update the displayed row immediately
  detail.taxType = match.gst_id;
}




  // onTaxChange(detail: any) {
  //   if (!detail.hsn_sac) {
  //     detail.hsn_sac = {};
  //   }
  //   detail.hsn_sac.gst_id = detail.taxType;
  // }
onTaxChange(detail: any) {
  const gstId = detail.taxType ? parseInt(detail.taxType, 10) : detail.taxType;

  this.data.productList.forEach(product => {
    product.details?.forEach(d => {

      const sameItem =
        (detail.item_service_type === 'SKU' &&
          d.item_service_type === 'SKU' &&
          (d.sku_id || d?.sku?.id) === (detail.sku_id || detail?.sku?.id)) ||

        (detail.item_service_type === 'Service' &&
          d.item_service_type === 'Service' &&
          (d.service_id || d?.service?.id) === (detail.service_id || detail?.service?.id)) ||

        (detail.item_service_type === 'Fixed Asset' &&
          d.item_service_type === 'Fixed Asset' &&
          (d.sku_id || d?.fa_template?.id) === (detail.sku_id || detail?.fa_template?.id));

      const sameHsn = detail.hsn_no && d.hsn_no && detail.hsn_no === d.hsn_no;

      if (sameItem || sameHsn) {
        if (!d.hsn_sac) d.hsn_sac = {};
        d.taxType = detail.taxType;
        d.hsn_sac.gst_id = gstId;
      }
    });
  });

  this.productList.forEach(product => {
    product.details?.forEach(d => {
      if (detail.hsn_no && d.hsn_no && detail.hsn_no === d.hsn_no) {
        d.taxType = detail.taxType;
        if (!d.hsn_sac) d.hsn_sac = {};
        d.hsn_sac.gst_id = gstId;
      }
    });
  });
}




onSave(): void {

  // original full data (used by table & API)
  const originalProductList = this.data.productList;

  // edited unique rows
  this.productList.forEach(editedProduct => {
    editedProduct.details.forEach(editedDetail => {

      originalProductList.forEach(originalProduct => {
        originalProduct.details.forEach(originalDetail => {

          const isSameItem =
            editedDetail.item_service_type === 'SKU' &&
            originalDetail.item_service_type === 'SKU' &&
            (editedDetail.sku_id || editedDetail?.sku?.id) ===
            (originalDetail.sku_id || originalDetail?.sku?.id);

          const isSameService =
            editedDetail.item_service_type === 'Service' &&
            originalDetail.item_service_type === 'Service' &&
            (editedDetail.service_id || editedDetail?.service?.id) ===
            (originalDetail.service_id || originalDetail?.service?.id);

          const isSameFixedAsset =
            editedDetail.item_service_type === 'Fixed Asset' &&
            originalDetail.item_service_type === 'Fixed Asset' &&
            (editedDetail.sku_id || editedDetail?.fa_template?.id) ===
            (originalDetail.sku_id || originalDetail?.fa_template?.id);

          if (isSameItem || isSameService || isSameFixedAsset) {
            // 🔥 APPLY EDIT TO ALL MATCHING DETAILS
            originalDetail.hsn_no = editedDetail.hsn_no;
            
            // If HSN changed or didn't exist, replace the whole object
            // Otherwise, preserve existing properties and just update what changed
            if (!originalDetail.hsn_sac || originalDetail.hsn_sac.hsn_sac_no !== editedDetail.hsn_no) {
                originalDetail.hsn_sac = editedDetail.hsn_sac ? { ...editedDetail.hsn_sac } : {};
            } else if (editedDetail.hsn_sac && Object.keys(editedDetail.hsn_sac).length > 0) {
                 // Even if same HSN, if edit has better data, use it
                 originalDetail.hsn_sac = { ...originalDetail.hsn_sac, ...editedDetail.hsn_sac };
            }
            
            if (!originalDetail.hsn_sac) originalDetail.hsn_sac = {};
            originalDetail.hsn_sac.hsn_sac_no = editedDetail.hsn_no;
            
            const gstId = editedDetail.taxType ? parseInt(editedDetail.taxType, 10) : editedDetail.taxType;
            originalDetail.hsn_sac.gst_id = gstId;

            originalDetail.taxType = editedDetail.taxType;
            originalDetail.specification = editedDetail.specification;
          }
        });
      });

    });
  });

  // close dialog and return FULL updated list
  this.dialogRef.close(originalProductList);
}


  onCancel(): void {
    this.dialogRef.close();
  }
}

